<template>
  <div>
    <el-input v-model="value">
      <template slot="append">
        <el-button @click="dialogVisible=true">选择音频</el-button>
      </template>
    </el-input>
    <div class="image-slot" style="width: 8rem;margin-top: .5rem">
      <i class="el-icon-mic"></i>
      <a v-if="value" :href="value | tomedia" target="_blank" class="y-desc">点击预览</a>
    </div>
    <el-dialog append-to-body title="选择音频" :show-close="false" :visible.sync="dialogVisible" width="50rem" @open="open" :before-close="handleClose">
      <el-upload
          style="position: absolute;right: 1.5rem;top: 1.5rem;"
          ref="uploader"
          :action="action"
          :headers="{ytoken:vuex_token.data}"
          name="file"
          :show-file-list="false"
          accept="audio/mp3"
          :on-success="success"
          :on-error="error"
          :limit="1"
      >
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
      <div style="position:absolute;left: 10rem;top: 1.2rem;width: 40rem">
        <el-row :gutter="40">
          <el-col :span="8">
            <el-input v-model="searchForm.title" placeholder="请输入要搜素的名称"></el-input>
          </el-col>
          <el-col :span="6">
            <el-button-group>
              <el-button @click="searchGo" type="primary">搜索</el-button>
              <el-button @click="searchReset">重置</el-button>
            </el-button-group>
          </el-col>
        </el-row>
      </div>
      <div class="flex-def flex-warp" style="min-height: 18rem">
        <div class="flex-def flex-zCenter flex-cCenter" v-for="(item,key) in list" :key="key" style="margin: .5rem;position: relative;width: calc(20% - 1rem);height: 8rem">
          <div class="flex-def flex-zCenter flex-cCenter" style="width: 8rem;position: relative">
            <div @click="choose(item)" class="y-pointer image-slot flex-def flex-zTopBottom" style="width: 8rem;height: 8rem">
              <i class="el-icon-mic" style="font-size: 4rem"></i>
            </div>
            <confirm-input :sync="false" style="position: absolute;bottom: 0;" @confirm="renameTitle($event,item.id)" v-model="item.filename">
              <div class="y-pointer flex-def flex-zCenter flex-cCenter" style="color: #FFFFFF;background-color: rgba(0,0,0,.4);font-size: .8rem;line-height: 1.5rem;width: 8rem">
                <div class="text-ellipsis" style="width: 95%">{{item.filename}}</div>
              </div>
            </confirm-input>
            <div style="position: absolute;right: 0;top: 0;">
              <el-popconfirm @confirm="del(item)" title="确定删除吗？">
                <div slot="reference" class="flex-def flex-zCenter flex-cCenter" style="padding: .2rem;background-color: red;color: #FFFFFF">
                  <i class="el-icon-delete-solid"></i>
                </div>
              </el-popconfirm>
            </div>

          </div>
        </div>
        <div v-if="list.length === 0" class="flex-def flex-zCenter flex-cCenter" style="width: 100%;font-size: 1rem;color: #ededed;font-weight: 600">
          还没有资源...
        </div>
      </div>
      <template #footer>
        <el-pagination :hide-on-single-page="true" style="padding: .5rem" background layout="total,prev, pager,next"
                       :total="total" :page-size="15" :current-page="page" @current-change="pageChange">
        </el-pagination>
      </template>
    </el-dialog>
  </div>
</template>

<script>


import {requestWithUni} from "@/common/resquest";
import ConfirmInput from "@/components/y-form/confirm-input/confirmInput";

export default {
  name: "y_upload_audio_box",
  components: {ConfirmInput},
  model:{
    prop:"modelval",
    event:'change'
  },
  props:{
    full:{
      type:Boolean,
      default: false
    },
    modelval: {
      type:String,
      default:""
    }
  },
  watch:{
    modelval(){
      this.value = this.modelval;
    },
    value(e){
      this.$emit('change',e);
    }
  },
  data() {
    return {
      action:"",
      dialogVisible: false,
      value: this.modelval,
      page:1,
      list:[],
      total:0,
      searchForm:{
        title:""
      }
    }
  },
  mounted() {
    this.action = requestWithUni(this.axios.defaults.baseURL + this.$u.api.attach.uploadAction);
  },
  methods:{
    renameTitle(title,id){
      this.$u.api.attach.renameTitle({title,id}).then(()=>{
        this.$message.success("操作成功");
        this.loadList();
      })
    },
    open(){
      this.loadList();
    },
    del(item){
      this.$u.api.attach.del({id:item.id}).then(()=>{
        this.loadList();
      })
    },
    pageChange(cur){
      this.page = cur;
      this.loadList();
    },
    searchReset(){
      this.searchForm = {
        title:""
      }
      this.searchGo();
    },
    searchGo(){
      this.page = 1;
      this.list = [];
      this.loadList();
    },
    loadList(){
      this.$u.api.attach.page({
        page:this.page,
        type:2,
        title:this.searchForm.title
      }).then(res=>{
        this.list = res.list;
        this.total = res.total;
      })
    },
    success(e){
      if (e.message)this.$message.info(e.message);
      this.$refs.uploader.clearFiles();
      this.loadList();
    },
    error(e){
      console.log(e)
    },
    choose(audio){
      this.dialogVisible=false;
      if(this.full){
        this.value = this.$u.toMedia(audio.attachment);
        return;
      }
      this.value = audio.attachment;
    },
    handleClose(done){
      done();
    },
  }
}
</script>
<style scoped>

</style>
<style>
.image-slot {
  width: 3rem;
  height: 3rem;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}
</style>